module.exports = __webpack_public_path__ + "img/feedback.b7e002b7.png";